var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 198.5,
    stroke: "#BAA0E2",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeDasharray: "11 11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEllipse);
export default __webpack_public_path__ + "static/media/ic_ellipse.b728bb1806a983ad597ff54078432f82.svg";
export { ForwardRef as ReactComponent };